import {
  conformsTo,
  isArrayAndEveryElement,
  isBoolean,
  isRecordWith,
  isString,
  isUndefinedOr,
  isUnknown,
} from '../../typing/guards';
import { Command, isCommandWithPayload } from './command';

export interface CommandResponse {
  readonly command: Command<unknown>;
  readonly ok: boolean;
  readonly info?: Record<string, string>[];
}

export const isCommandResponse = conformsTo<CommandResponse>({
  command: isCommandWithPayload(isUnknown),
  ok: isBoolean,
  info: isUndefinedOr(isArrayAndEveryElement(isRecordWith(isString, isString))),
});
